var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalContainer',{attrs:{"hideClose":"true"}},[_c('div',{staticClass:"wrapperInner"},[_c('p',[_vm._v("Updating the Template from Figma file. Please wait...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }